import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Route, RouterModule } from '@angular/router';
import {accessTokenGuard} from "../../core/guards/access-token.guard";
import {EAccessType} from "../../core/enums/access-type.enum";

const routes: Route[] = [
  {
    path: '',
    redirectTo: 'dashboard/home',
    pathMatch: 'full',
  },
  {
    path: 'dashboard',
    canActivate: [accessTokenGuard],
    data: { allowedAccessToken: EAccessType.FAT,},
    children: [
      {
        path: 'home',
        loadChildren: () =>
           import('./modules/home/home.module').then(
            ({ HomeModule }) => HomeModule
          ),
      },

    ],
  },
];

@NgModule({
  declarations: [],
  imports: [CommonModule, RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DashboardRoutingModule {}
